// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const beheeyem: PokeData = {
  "id": 606,
  "name": "beheeyem",
  "height": 10,
  "weight": 345,
  "base_experience": 170,
  "types": [
    PokeType.PSYCHIC
  ],
  "api_moves": [
    "headbutt",
    "growl",
    "psybeam",
    "confusion",
    "psychic",
    "teleport",
    "recover",
    "hidden-power",
    "psych-up",
    "imprison",
    "calm-mind",
    "miracle-eye",
    "heal-block",
    "zen-headbutt",
    "guard-split",
    "power-split",
    "wonder-room",
    "synchronoise",
    "simple-beam",
    "psychic-terrain"
  ],
  "moves": [
    "headbutt",
    "growl",
    "psychic",
    "calm-mind",
    "zen-headbutt",
    "psychic-terrain",
    "psywave",
    "psy-ball",
    "future-sight",
    "psy-pulse",
    "prismatic-cage",
    "psychic-fangs",
    "healing-wish"
  ],
  "evolution_chain": {
    "id": 307,
    "item": null,
    "species": [
      {
        "name": "elgyem",
        "order": 606,
        "types": [
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "beheeyem",
        "order": 607,
        "types": [
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": 605,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 42,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 131,
    "speed": 65,
    "ability_power": 204
  },
  "stat_changes": [],
  "catch_rate": 90,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
